import i18n from "@/i18n";
import { enumToSelectOptions, enumCodeToLabel } from "../../BaseEnum";
import { FuelType } from "./FuelType";

export class ActualFuel {
  static GASEOUS_NATURAL_GAS = 1;
  static GASEOUS_CNG = 2;
  static GASEOUS_LNG = 3;
  static GASEOUS_LPG = 4;
  static GASEOUS_BUTANE = 5;
  static GASEOUS_OTHER_PETROLEUM_GAS = 6;
  static GASEOUS_PROPANE = 7;
  static GASEOUS_BIOGAS = 8;
  static GASEOUS_LANDFILL_GAS = 9;
  static LIQUID_DIESEL_GAS_OIL = 10;
  static LIQUID_PETROL_GASOLINE = 11;
  static LIQUID_AVIATION_SPIRIT = 12;
  static LIQUID_AVIATION_TURBINE_FUEL = 13;
  static LIQUID_AVTUR_RENEWABLE = 14;
  static LIQUID_MARINE_GAS_OIL = 15;
  static LIQUID_MARINE_FUEL_OIL = 16;
  static LIQUID_BIOETHANOL = 17;
  static LIQUID_BIODIESEL_ME = 18;
  static LIQUID_BIOMETHANE_COMPRESSED = 19;
  static LIQUID_BIODIESEL_ME_USED_COOKING_OIL = 20;
  static LIQUID_BIODIESEL_ME_TALLOW = 21;
  static LIQUID_BIODIESEL_HVO = 22;
  static LIQUID_BIOPROPANE = 23;
  static LIQUID_DEVELOPMENT_DIESEL = 24;
  static LIQUID_DEVELOPMENT_PETROL = 25;
  static LIQUID_OFF_ROAD_BIODIESEL = 26;
  static LIQUID_BIOMETHANE_LIQUEFIED = 27;
  static LIQUID_METHANOL_BIO = 28;
  static LIQUID_BURNING_OIL = 29;
  static LIQUID_FUEL_OIL = 30;
  static LIQUID_GAS_OIL = 31;
  static LIQUID_LUBRICANTS = 32;
  static LIQUID_NAPHTHA = 33;
  static LIQUID_PROCESSED_FUEL_OILS_RESIDUAL_OIL = 34;
  static LIQUID_PROCESSED_FUEL_OILS_DISTILLATE_OIL = 35;
  static LIQUID_REFINERY_MISCELLANEOUS = 36;
  static LIQUID_WASTE_OILS = 37;
  static SOLID_COAL_INDUSTRIAL = 38;
  static SOLID_COAL_ELECTRICITY_GENERATION = 39;
  static SOLID_COAL_DOMESTIC = 40;
  static SOLID_COKING_COAL = 41;
  static SOLID_PETROLEUM_COKE = 42;
  static SOLID_COAL_ELECTRICITY_GENERATION_HOME_PRODUCED = 43;
  static BIOMASS_WOOD_LOGS = 44;
  static BIOMASS_WOOD_CHIPS = 45;
  static BIOMASS_WOOD_PELLETS = 46;
  static BIOMASS_GRASS_STRAW = 47;
  static COAL_AND_COKE_ANTHRACITE = 48;
  static COAL_AND_COKE_BITUMINOUS = 49;
  static COAL_AND_COKE_SUB_BITUMINOUS = 50;
  static COAL_AND_COKE_LIGNITE = 51;
  static COAL_AND_COKE_MIXED_COMMERCIAL_SECTOR = 52;
  static COAL_AND_COKE_MIXED_ELECTRIC_POWER_SECTOR = 53;
  static COAL_AND_COKE_MIXED_INDUSTRIAL_COKING = 54;
  static COAL_AND_COKE_MIXED_INDUSTRIAL_SECTOR = 55;
  static COAL_AND_COKE_COAL_COKE = 56;
  static OTHER_SOLID_MUNICIPAL_SOLID_WASTE = 57;
  static OTHER_SOLID_PETROLEUM_COKE = 58;
  static OTHER_SOLID_PLASTICS = 59;
  static OTHER_SOLID_TIRES = 60;
  static BIOMASS_SOLID_AGRICULTURAL_BYPRODUCTS = 61;
  static BIOMASS_SOLID_PEAT = 62;
  static BIOMASS_SOLID_SOLID_BYPRODUCTS = 63;
  static BIOMASS_SOLID_WOOD_AND_RESIDUALS = 64;
  static NATURAL_GAS_NATURAL_GAS = 65;
  static OTHER_GASEOUS_BLAST_FURNACE_GAS = 66;
  static OTHER_GASEOUS_COKE_OVEN_GAS = 67;
  static OTHER_GASEOUS_FUEL_GAS = 68;
  static OTHER_GASEOUS_PROPANE_GAS = 69;
  static BIOMASS_GASEOUS_LANDFILL_GAS = 70;
  static BIOMASS_GASEOUS_OTHER_BIOMASS_GASES = 71;
  static PETROLEUM_PRODUCTS_ASPHALT_AND_ROAD_OIL = 72;
  static PETROLEUM_PRODUCTS_AVIATION_GASOLINE = 73;
  static PETROLEUM_PRODUCTS_BUTANE = 74;
  static PETROLEUM_PRODUCTS_BUTYLENE = 75;
  static PETROLEUM_PRODUCTS_CRUDE_OIL = 76;
  static PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_1 = 77;
  static PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_2 = 78;
  static PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_4 = 79;
  static PETROLEUM_PRODUCTS_ETHANE = 80;
  static PETROLEUM_PRODUCTS_ETHYLENE = 81;
  static PETROLEUM_PRODUCTS_HEAVY_GAS_OILS = 82;
  static PETROLEUM_PRODUCTS_ISOBUTANE = 83;
  static PETROLEUM_PRODUCTS_ISOBUTYLENE = 84;
  static PETROLEUM_PRODUCTS_KEROSENE = 85;
  static PETROLEUM_PRODUCTS_KEROSENE_TYPE_JET_FUEL = 86;
  static PETROLEUM_PRODUCTS_LPG = 87;
  static PETROLEUM_PRODUCTS_LUBRICANTS = 88;
  static PETROLEUM_PRODUCTS_MOTOR_GASOLINE = 89;
  static PETROLEUM_PRODUCTS_NAPHTHA_LT_401F = 90;
  static PETROLEUM_PRODUCTS_NATURAL_GASOLINE = 91;
  static PETROLEUM_PRODUCTS_OTHER_OIL_GT_401F = 92;
  static PETROLEUM_PRODUCTS_PENTANES_PLUS = 93;
  static PETROLEUM_PRODUCTS_PETROCHEMICAL_FEEDSTOCKS = 94;
  static PETROLEUM_PRODUCTS_PROPANE = 95;
  static PETROLEUM_PRODUCTS_PROPYLENE = 96;
  static PETROLEUM_PRODUCTS_RESIDUAL_FUEL_OIL_NO_5 = 97;
  static PETROLEUM_PRODUCTS_RESIDUAL_FUEL_OIL_NO_6 = 98;
  static PETROLEUM_PRODUCTS_SPECIAL_NAPHTHA = 99;
  static PETROLEUM_PRODUCTS_UNFINISHED_OILS = 100;
  static PETROLEUM_PRODUCTS_USED_OIL = 101;
  static BIOMASS_LIQUID_BIODIESEL_100 = 102;
  static BIOMASS_LIQUID_ETHANOL_100 = 103;
  static BIOMASS_LIQUID_RENDERED_ANIMAL_FAT = 104;
  static BIOMASS_LIQUID_VEGETABLE_OIL = 105;
  static BIOMASS_KRAFT_PULPING_LIQUOR_NORTH_AMERICAN_SOFTWOOD = 106;
  static BIOMASS_KRAFT_PULPING_LIQUOR_NORTH_AMERICAN_HARDWOOD = 107;
  static BIOMASS_KRAFT_PULPING_LIQUOR_BAGASSE = 108;
  static BIOMASS_KRAFT_PULPING_LIQUOR_BAMBOO = 109;
  static BIOMASS_KRAFT_PULPING_LIQUOR_STRAW = 110;

  static Items = [
    {
      code: this.GASEOUS_NATURAL_GAS,
      key: "GASEOUS_NATURAL_GAS",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_CNG,
      key: "GASEOUS_CNG",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_LNG,
      key: "GASEOUS_LNG",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_LPG,
      key: "GASEOUS_LPG",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_BUTANE,
      key: "GASEOUS_BUTANE",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_OTHER_PETROLEUM_GAS,
      key: "GASEOUS_OTHER_PETROLEUM_GAS",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_PROPANE,
      key: "GASEOUS_PROPANE",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_BIOGAS,
      key: "GASEOUS_BIOGAS",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.GASEOUS_LANDFILL_GAS,
      key: "GASEOUS_LANDFILL_GAS",
      fuelType: FuelType.GASEOUS_FUELS,
    },
    {
      code: this.LIQUID_DIESEL_GAS_OIL,
      key: "LIQUID_DIESEL_GAS_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_PETROL_GASOLINE,
      key: "LIQUID_PETROL_GASOLINE",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_AVIATION_SPIRIT,
      key: "LIQUID_AVIATION_SPIRIT",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_AVIATION_TURBINE_FUEL,
      key: "LIQUID_AVIATION_TURBINE_FUEL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_AVTUR_RENEWABLE,
      key: "LIQUID_AVTUR_RENEWABLE",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_MARINE_GAS_OIL,
      key: "LIQUID_MARINE_GAS_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_MARINE_FUEL_OIL,
      key: "LIQUID_MARINE_FUEL_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIOETHANOL,
      key: "LIQUID_BIOETHANOL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIODIESEL_ME,
      key: "LIQUID_BIODIESEL_ME",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIOMETHANE_COMPRESSED,
      key: "LIQUID_BIOMETHANE_COMPRESSED",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIODIESEL_ME_USED_COOKING_OIL,
      key: "LIQUID_BIODIESEL_ME_USED_COOKING_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIODIESEL_ME_TALLOW,
      key: "LIQUID_BIODIESEL_ME_TALLOW",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIODIESEL_HVO,
      key: "LIQUID_BIODIESEL_HVO",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIOPROPANE,
      key: "LIQUID_BIOPROPANE",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_DEVELOPMENT_DIESEL,
      key: "LIQUID_DEVELOPMENT_DIESEL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_DEVELOPMENT_PETROL,
      key: "LIQUID_DEVELOPMENT_PETROL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_OFF_ROAD_BIODIESEL,
      key: "LIQUID_OFF_ROAD_BIODIESEL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BIOMETHANE_LIQUEFIED,
      key: "LIQUID_BIOMETHANE_LIQUEFIED",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_METHANOL_BIO,
      key: "LIQUID_METHANOL_BIO",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_BURNING_OIL,
      key: "LIQUID_BURNING_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_FUEL_OIL,
      key: "LIQUID_FUEL_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_GAS_OIL,
      key: "LIQUID_GAS_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_LUBRICANTS,
      key: "LIQUID_LUBRICANTS",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_NAPHTHA,
      key: "LIQUID_NAPHTHA",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_PROCESSED_FUEL_OILS_RESIDUAL_OIL,
      key: "LIQUID_PROCESSED_FUEL_OILS_RESIDUAL_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_PROCESSED_FUEL_OILS_DISTILLATE_OIL,
      key: "LIQUID_PROCESSED_FUEL_OILS_DISTILLATE_OIL",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_REFINERY_MISCELLANEOUS,
      key: "LIQUID_REFINERY_MISCELLANEOUS",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.LIQUID_WASTE_OILS,
      key: "LIQUID_WASTE_OILS",
      fuelType: FuelType.LIQUID_FUELS,
    },
    {
      code: this.SOLID_COAL_INDUSTRIAL,
      key: "SOLID_COAL_INDUSTRIAL",
      fuelType: FuelType.SOLID_FUELS,
    },
    {
      code: this.SOLID_COAL_ELECTRICITY_GENERATION,
      key: "SOLID_COAL_ELECTRICITY_GENERATION",
      fuelType: FuelType.SOLID_FUELS,
    },
    {
      code: this.SOLID_COAL_DOMESTIC,
      key: "SOLID_COAL_DOMESTIC",
      fuelType: FuelType.SOLID_FUELS,
    },
    {
      code: this.SOLID_COKING_COAL,
      key: "SOLID_COKING_COAL",
      fuelType: FuelType.SOLID_FUELS,
    },
    {
      code: this.SOLID_PETROLEUM_COKE,
      key: "SOLID_PETROLEUM_COKE",
      fuelType: FuelType.SOLID_FUELS,
    },
    {
      code: this.SOLID_COAL_ELECTRICITY_GENERATION_HOME_PRODUCED,
      key: "SOLID_COAL_ELECTRICITY_GENERATION_HOME_PRODUCED",
      fuelType: FuelType.SOLID_FUELS,
    },
    {
      code: this.BIOMASS_WOOD_LOGS,
      key: "BIOMASS_WOOD_LOGS",
      fuelType: FuelType.BIOMASS,
    },
    {
      code: this.BIOMASS_WOOD_CHIPS,
      key: "BIOMASS_WOOD_CHIPS",
      fuelType: FuelType.BIOMASS,
    },
    {
      code: this.BIOMASS_WOOD_PELLETS,
      key: "BIOMASS_WOOD_PELLETS",
      fuelType: FuelType.BIOMASS,
    },
    {
      code: this.BIOMASS_GRASS_STRAW,
      key: "BIOMASS_GRASS_STRAW",
      fuelType: FuelType.BIOMASS,
    },
    {
      code: this.COAL_AND_COKE_ANTHRACITE,
      key: "COAL_AND_COKE_ANTHRACITE",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_BITUMINOUS,
      key: "COAL_AND_COKE_BITUMINOUS",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_SUB_BITUMINOUS,
      key: "COAL_AND_COKE_SUB_BITUMINOUS",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_LIGNITE,
      key: "COAL_AND_COKE_LIGNITE",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_MIXED_COMMERCIAL_SECTOR,
      key: "COAL_AND_COKE_MIXED_COMMERCIAL_SECTOR",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_MIXED_ELECTRIC_POWER_SECTOR,
      key: "COAL_AND_COKE_MIXED_ELECTRIC_POWER_SECTOR",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_MIXED_INDUSTRIAL_COKING,
      key: "COAL_AND_COKE_MIXED_INDUSTRIAL_COKING",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_MIXED_INDUSTRIAL_SECTOR,
      key: "COAL_AND_COKE_MIXED_INDUSTRIAL_SECTOR",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.COAL_AND_COKE_COAL_COKE,
      key: "COAL_AND_COKE_COAL_COKE",
      fuelType: FuelType.COAL_AND_COKE,
    },
    {
      code: this.OTHER_SOLID_MUNICIPAL_SOLID_WASTE,
      key: "OTHER_SOLID_MUNICIPAL_SOLID_WASTE",
      fuelType: FuelType.OTHER_FUELS_SOLID,
    },
    {
      code: this.OTHER_SOLID_PETROLEUM_COKE,
      key: "OTHER_SOLID_PETROLEUM_COKE",
      fuelType: FuelType.OTHER_FUELS_SOLID,
    },
    {
      code: this.OTHER_SOLID_PLASTICS,
      key: "OTHER_SOLID_PLASTICS",
      fuelType: FuelType.OTHER_FUELS_SOLID,
    },
    {
      code: this.OTHER_SOLID_TIRES,
      key: "OTHER_SOLID_TIRES",
      fuelType: FuelType.OTHER_FUELS_SOLID,
    },
    {
      code: this.BIOMASS_SOLID_AGRICULTURAL_BYPRODUCTS,
      key: "BIOMASS_SOLID_AGRICULTURAL_BYPRODUCTS",
      fuelType: FuelType.BIOMASS_FUELS_SOLID,
    },
    {
      code: this.BIOMASS_SOLID_PEAT,
      key: "BIOMASS_SOLID_PEAT",
      fuelType: FuelType.BIOMASS_FUELS_SOLID,
    },
    {
      code: this.BIOMASS_SOLID_SOLID_BYPRODUCTS,
      key: "BIOMASS_SOLID_SOLID_BYPRODUCTS",
      fuelType: FuelType.BIOMASS_FUELS_SOLID,
    },
    {
      code: this.BIOMASS_SOLID_WOOD_AND_RESIDUALS,
      key: "BIOMASS_SOLID_WOOD_AND_RESIDUALS",
      fuelType: FuelType.BIOMASS_FUELS_SOLID,
    },
    {
      code: this.NATURAL_GAS_NATURAL_GAS,
      key: "NATURAL_GAS_NATURAL_GAS",
      fuelType: FuelType.NATURAL_GAS,
    },
    {
      code: this.OTHER_GASEOUS_BLAST_FURNACE_GAS,
      key: "OTHER_GASEOUS_BLAST_FURNACE_GAS",
      fuelType: FuelType.OTHER_FUELS_GASEOUS,
    },
    {
      code: this.OTHER_GASEOUS_COKE_OVEN_GAS,
      key: "OTHER_GASEOUS_COKE_OVEN_GAS",
      fuelType: FuelType.OTHER_FUELS_GASEOUS,
    },
    {
      code: this.OTHER_GASEOUS_FUEL_GAS,
      key: "OTHER_GASEOUS_FUEL_GAS",
      fuelType: FuelType.OTHER_FUELS_GASEOUS,
    },
    {
      code: this.OTHER_GASEOUS_PROPANE_GAS,
      key: "OTHER_GASEOUS_PROPANE_GAS",
      fuelType: FuelType.OTHER_FUELS_GASEOUS,
    },
    {
      code: this.BIOMASS_GASEOUS_LANDFILL_GAS,
      key: "BIOMASS_GASEOUS_LANDFILL_GAS",
      fuelType: FuelType.BIOMASS_FUELS_GASEOUS,
    },
    {
      code: this.BIOMASS_GASEOUS_OTHER_BIOMASS_GASES,
      key: "BIOMASS_GASEOUS_OTHER_BIOMASS_GASES",
      fuelType: FuelType.BIOMASS_FUELS_GASEOUS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_ASPHALT_AND_ROAD_OIL,
      key: "PETROLEUM_PRODUCTS_ASPHALT_AND_ROAD_OIL",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_AVIATION_GASOLINE,
      key: "PETROLEUM_PRODUCTS_AVIATION_GASOLINE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_BUTANE,
      key: "PETROLEUM_PRODUCTS_BUTANE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_BUTYLENE,
      key: "PETROLEUM_PRODUCTS_BUTYLENE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_CRUDE_OIL,
      key: "PETROLEUM_PRODUCTS_CRUDE_OIL",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_1,
      key: "PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_1",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_2,
      key: "PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_2",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_4,
      key: "PETROLEUM_PRODUCTS_DISTILLATE_FUEL_OIL_NO_4",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_ETHANE,
      key: "PETROLEUM_PRODUCTS_ETHANE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_ETHYLENE,
      key: "PETROLEUM_PRODUCTS_ETHYLENE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_HEAVY_GAS_OILS,
      key: "PETROLEUM_PRODUCTS_HEAVY_GAS_OILS",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_ISOBUTANE,
      key: "PETROLEUM_PRODUCTS_ISOBUTANE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_ISOBUTYLENE,
      key: "PETROLEUM_PRODUCTS_ISOBUTYLENE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_KEROSENE,
      key: "PETROLEUM_PRODUCTS_KEROSENE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_KEROSENE_TYPE_JET_FUEL,
      key: "PETROLEUM_PRODUCTS_KEROSENE_TYPE_JET_FUEL",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_LPG,
      key: "PETROLEUM_PRODUCTS_LPG",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_LUBRICANTS,
      key: "PETROLEUM_PRODUCTS_LUBRICANTS",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_MOTOR_GASOLINE,
      key: "PETROLEUM_PRODUCTS_MOTOR_GASOLINE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_NAPHTHA_LT_401F,
      key: "PETROLEUM_PRODUCTS_NAPHTHA_LT_401F",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_NATURAL_GASOLINE,
      key: "PETROLEUM_PRODUCTS_NATURAL_GASOLINE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_OTHER_OIL_GT_401F,
      key: "PETROLEUM_PRODUCTS_OTHER_OIL_GT_401F",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_PENTANES_PLUS,
      key: "PETROLEUM_PRODUCTS_PENTANES_PLUS",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_PETROCHEMICAL_FEEDSTOCKS,
      key: "PETROLEUM_PRODUCTS_PETROCHEMICAL_FEEDSTOCKS",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_PROPANE,
      key: "PETROLEUM_PRODUCTS_PROPANE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_PROPYLENE,
      key: "PETROLEUM_PRODUCTS_PROPYLENE",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_RESIDUAL_FUEL_OIL_NO_5,
      key: "PETROLEUM_PRODUCTS_RESIDUAL_FUEL_OIL_NO_5",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_RESIDUAL_FUEL_OIL_NO_6,
      key: "PETROLEUM_PRODUCTS_RESIDUAL_FUEL_OIL_NO_6",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_SPECIAL_NAPHTHA,
      key: "PETROLEUM_PRODUCTS_SPECIAL_NAPHTHA",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_UNFINISHED_OILS,
      key: "PETROLEUM_PRODUCTS_UNFINISHED_OILS",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.PETROLEUM_PRODUCTS_USED_OIL,
      key: "PETROLEUM_PRODUCTS_USED_OIL",
      fuelType: FuelType.PETROLEUM_PRODUCTS,
    },
    {
      code: this.BIOMASS_LIQUID_BIODIESEL_100,
      key: "BIOMASS_LIQUID_BIODIESEL_100",
      fuelType: FuelType.BIOMASS_FUELS_LIQUID,
    },
    {
      code: this.BIOMASS_LIQUID_ETHANOL_100,
      key: "BIOMASS_LIQUID_ETHANOL_100",
      fuelType: FuelType.BIOMASS_FUELS_LIQUID,
    },
    {
      code: this.BIOMASS_LIQUID_RENDERED_ANIMAL_FAT,
      key: "BIOMASS_LIQUID_RENDERED_ANIMAL_FAT",
      fuelType: FuelType.BIOMASS_FUELS_LIQUID,
    },
    {
      code: this.BIOMASS_LIQUID_VEGETABLE_OIL,
      key: "BIOMASS_LIQUID_VEGETABLE_OIL",
      fuelType: FuelType.BIOMASS_FUELS_LIQUID,
    },
    {
      code: this.BIOMASS_KRAFT_PULPING_LIQUOR_NORTH_AMERICAN_SOFTWOOD,
      key: "BIOMASS_KRAFT_PULPING_LIQUOR_NORTH_AMERICAN_SOFTWOOD",
      fuelType: FuelType.BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH,
    },
    {
      code: this.BIOMASS_KRAFT_PULPING_LIQUOR_NORTH_AMERICAN_HARDWOOD,
      key: "BIOMASS_KRAFT_PULPING_LIQUOR_NORTH_AMERICAN_HARDWOOD",
      fuelType: FuelType.BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH,
    },
    {
      code: this.BIOMASS_KRAFT_PULPING_LIQUOR_BAGASSE,
      key: "BIOMASS_KRAFT_PULPING_LIQUOR_BAGASSE",
      fuelType: FuelType.BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH,
    },
    {
      code: this.BIOMASS_KRAFT_PULPING_LIQUOR_BAMBOO,
      key: "BIOMASS_KRAFT_PULPING_LIQUOR_BAMBOO",
      fuelType: FuelType.BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH,
    },
    {
      code: this.BIOMASS_KRAFT_PULPING_LIQUOR_STRAW,
      key: "BIOMASS_KRAFT_PULPING_LIQUOR_STRAW",
      fuelType: FuelType.BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH,
    },
  ];

  static Codes = ActualFuel.Items.map(({ code }) => code);

  static get Labels() {
    return ActualFuel.Items.map(({ key }) =>
      i18n.t(`enums.actual-fuel.${key}`)
    );
  }

  static toSelectOptions(from, to) {
    return enumToSelectOptions(ActualFuel.Codes, this.Labels, from, to);
  }

  static codeToLabel(code) {
    return enumCodeToLabel(ActualFuel.Codes, this.Labels, code);
  }

  static codeToFuelType(code) {
    const entry = ActualFuel.Items.find((item) => item.code === code);
    return entry ? entry.fuelType : "";
  }
}
